import { setLocale, getLocale } from "./SettingsRetriever";

export default () => {
    const path = window.location.href.split("//")[1].split("/")[1];
    if (path.length === 2 && path.substring(0,1) !== 'v') {
        if (path !== getLocale()){
            setLocale(path);
            window.location.reload();
        }
    }
};
